<template>
  <div class="container">
     <div class="banner" :style="'background-image:url('+ bannerUrl +')'">
      <Nav></Nav> 
    </div>
     <!--中间部分-->
     <div class="category">
      <div class="choice">
        <div class="admission" @click="tab(0)"  :class="value == '0' ? 'xiaxian' : ''">
          <img :src="value==0 ? require('../../assets/3.png') : require('../../assets/4.png')" alt="">
          <p :class="value == '0' ? 'yanse' : ''">报名录取</p>
        </div>
        <div class="recruit" @click="tab(1)"  :class="value == '1' ? 'xiaxian' : ''">
          <img :src="value==1 ? require('../../assets/1.png') : require('../../assets/2.png')" alt="">
          <p :class="value == '1' ? 'yanse' : ''">教师招聘</p>
        </div>
      </div>
     </div>
     <div class="middle">
        <!--录取-->
      <div class="luqu" v-if="value=='0'">
         <div class="top" v-for="(item,index) in list" :key="index">
            <div class="left">
              <div class="shu">
                <img src="../../assets/daiban_03.png" alt="">
              </div>
              <div class="jiaoshi">
                {{item.name}}
              </div>
              <div class="dibiao">
                <img src="../../assets/dibiao_07.png" alt="">
                <p>{{item.address}}</p>
              </div>
              <div class="jiaru">
                <a :href="'mailto:'+ item.email +''">我要加入</a>
              </div>
            </div>
            <div class="right" v-html="item.content">
            </div>
         </div>

      </div>
      <!--招聘-->
      <div class="luqu" v-if="value=='1'">
         <div class="top" v-for="(item,index) in list" :key="index">
         <div class="left">
           <div class="shu">
             <img src="../../assets/daiban_03.png" alt="">
           </div>
           <div class="jiaoshi">
             {{item.name}}
           </div>
           <div class="dibiao">
             <img src="../../assets/dibiao_07.png" alt="">
             <p>{{item.address}}</p>
           </div>
           <div class="jiaru">
              <a :href="'mailto:'+ item.email +''">我要加入</a>
           </div>
         </div>
         <div class="right" v-html="item.content">
           <!-- <div class="zhize">
             <p>让儿童在一个真实的世界里成长</p>
             <p>主要职责：</p>
             <p>1.负责幼儿园内的教学及协助后期服务工作：</p>
             <p>2.负责幼儿园的家庭教育指导工作；</p>
             <p>3.负责幼儿园的亲子早教工作；</p>
             <p>4.参与设计和组织项目制、个性化教学，科学合理地安排幼儿活动；</p>
             <p>5.收集整理家园教育资料，并及时归档。</p>
           </div>
           <div class="yaoqiu">
             <p>岗位要求：</p>
             <p>1. 她是肯干，喜欢和孩子一起工作；</p>
             <p>2. 年龄在40周岁以下的在职教师和优秀的应届或往届毕业生；</p>
             <p>3. 幼师学校毕业或有相关工作经验者优先录取。</p>
           </div> -->
         </div>
       </div>
       <!-- <div class="xian"></div> -->
       <!-- <div class="top">
         <div class="left">
           <div class="shu">
             <img src="../../assets/daiban_03.png" alt="">
           </div>
           <div class="jiaoshi">
             {{name}}
           </div>
           <div class="dibiao">
             <img src="../../assets/dibiao_07.png" alt="">
             <p>{{address}}</p>
           </div>
           <div class="jiaru">
              <a href="mailto:contact@lixiangguo.org.cn">我要加入</a>
           </div>
         </div>
         <div class="right" v-html="content">
           <div class="zhize">
             <p>让儿童在一个真实的世界里成长</p>
             <p>主要职责：</p>
             <p>1.负责幼儿园内的教学及协助后期服务工作：</p>
             <p>2.负责幼儿园的家庭教育指导工作；</p>
             <p>3.负责幼儿园的亲子早教工作；</p>
             <p>4.参与设计和组织项目制、个性化教学，科学合理地安排幼儿活动；</p>
             <p>5.收集整理家园教育资料，并及时归档。</p>
           </div>
           <div class="yaoqiu">
             <p>岗位要求：</p>
             <p>1. 她是肯干，喜欢和孩子一起工作；</p>
             <p>2. 年龄在40周岁以下的在职教师和优秀的应届或往届毕业生；</p>
             <p>3. 幼师学校毕业或有相关工作经验者优先录取。</p>
           </div>
         </div>
       </div> -->
      </div>
     </div>
     <!--底部-->
     <Footer></Footer>
  </div>
</template>
<script>
import Nav from '../../components/Nav'
import Footer from '../../components/Footer'
export default {
  components:{Nav,Footer},
  name:'Recruit',
  data(){
    return{
      value:0,
      
        bannerUrl:'',
        id:'',
        list:[
          { id:'',email:'',  name:'',address:'',   content:'',}
        ]
    }
  },
 
  methods:{
      tab(i){
        this.value=i;
         this.$http.post('/api/recruit/getList', {
      
        type:this.value+1
        }).then( (res)=> {
   
        var code=res.data.code;
        if(code===0){
        //  console.log(res.data.data.banner)
          this.list=res.data.data.list
          this.bannerUrl = res.data.data.banner
          // console.log(this.list)
        }
      }).catch(function (error) {
        //  console.log(error);
     });
        // console.log(i)
      },
      getList () {
      this.$http.post('/api/recruit/getList', {
        // page: this.pageVal,
        // pageSize:this.pageSize,
        // noPaginate:1,
        type:this.value+1
        }).then( (res)=> {
   
        var code=res.data.code;
        if(code===0){
          this.bannerUrl = res.data.data.banner
          this.list=res.data.data.list
        }
      }).catch(function (error) {
        //  console.log(error);
     });
  },
  },
   created(){
    this.$route.params.value
    // console.log(this.value)
    this.getList()
  },
}
</script>
<style scoped>
.container{
 background-color:rgb(244,247,250);
 min-width: max-content;
 min-width: -moz-max-content;
}
.xiaxian{
  border-bottom:3px solid rgb(247, 186, 49);
  width: 115px;
 
}
.yanse{
   color: rgb(247, 186, 49) !important;
}
.admission:hover,.recruit:hover{
  cursor: pointer;
}
.xian{
  border-bottom: 1px solid rgb(246, 213, 140);
  width: 100%;
  margin-top: 70px;
}
.banner{
  overflow: hidden !important;
}
.banner{
  position: relative;
  background-image: url('../../assets/banner5.png');
  width: 100%;
  min-width: 1200px;
  height: 366px;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}

.category{
  width: 100%;
  height: 70px;
  background: white;
  margin: 0 auto;
}
.category .choice{
  width: 430px;
  height: 70px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items:center;
}
.choice img{
  vertical-align: text-bottom;
  width: 20px;
  height: 20px;
}
.choice p{
  display: inline-block;
  font-size: 22px;
  color: rgb(89, 89, 89)
}
.middle{
  margin: 0 auto;
  width: 1200px;
  /* min-width: 900px; */
}
/* .luqu .top{
 
} */
.middle .top{
  /* width:100%; */
  /* height: 420px; */
  display: flex;
  justify-content: space-around;
  width: 80%;;
  margin: 0 auto;
  padding-bottom: 74px;
  border-bottom: 1px solid rgb(246, 213, 140);

}
.middle .top:last-child{
   border-bottom:none
}

.left{
  /* float: left; */
  height: 190px;
  display: flex;
  flex-direction:column;
  justify-content: space-between;
  align-items: center;
  /* margin-left:-70px; */
  line-height: 15px;
  margin-top:90px;
}
.right{
  width: 450px;
  margin-top:40px;
}
.dibiao p{
 display: inline-block;
}
.dibiao img{
  vertical-align: middle;
}
.zhize p:nth-child(1){
font-size: 16px;
font-weight: bolder;
color: rgb(59, 59, 60);
}
.zhize p:not(1){
font-size: 14px;
color:rgb(89, 89, 89);

}
.jiaru{
  background-color: rgb(191, 191, 191);
  color: white;
  padding: 10px 25px ;
  border-radius: 20px;
}
.jiaru a{
  text-decoration: none;
   color: white;
}
.jiaoshi{
  font-size: 14px;
  font-weight: bold;
  color:rgb(89, 89, 89)
}
.dibiao p{
   font-size: 14px;
   color:rgb(89, 89, 89)
}
.jiaru:hover{
  cursor: pointer;
}
.top:hover .jiaru{
  background-color: rgb(247, 186, 49)
}
.yaoqiu{
  margin-top: 40px;
}

</style>




// WEBPACK FOOTER //
// src/pages/pcPages/Recruit.vue